<template>
  <div>
    <main-layout :action="action" :subject="subject">
      <div slot="side-menu">
        <side-menu :user="me"></side-menu>
      </div>
      <div slot="header">
        <app-header
          :me="me"
          :activities="activities"
          :scheduledPosts="scheduledMessages"
          :companies="companies"
          :breadCrumbs="[]"
          @onNewSocialPost="onNewSocialPost"
          @onSearch="onSearch($event)"
          @onCollapseMenu="onCollapseMenu()"
          @onLogout="onLogout()"
        ></app-header>
      </div>
      <div slot="footer">
        <app-footer></app-footer>
      </div>
      <div slot="alerts">
        <staff-alerts></staff-alerts>
      </div>
      <div slot="toast">
        <toast />
        <notification />
      </div>
    </main-layout>
    <modal-container></modal-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AppFooter from '@/components/app/AppFooter';
import AppHeader from '@/components/app/AppHeader';
import MainLayout from '@/components/app/MainLayout';
import ModalContainer from '@/containers/modals/ModalContainer';
import Notification from '@/components/notifications/Notification';
import SideMenu from '@/components/app/SideMenu';
import StaffAlerts from '@/components/common/StaffAlerts';
import Toast from '@/components/common/Toast';

import * as appTypes from '@/store/app/mutation-types';
import * as interactionTypes from '@/store/modules/interaction/mutation-types/';
import * as authTypes from '@/store/modules/auth/mutation-types/';

export default {
  name: 'MainApp',
  components: {
    AppFooter,
    AppHeader,
    MainLayout,
    ModalContainer,
    Notification,
    SideMenu,
    StaffAlerts,
    Toast,
  },

  computed: {
    ...mapState('company', ['companies']),
    ...mapState('user', ['me']),
    ...mapState('activities', ['activities']),
    ...mapState('social', ['scheduledMessages']),

    action() {
      return this.$route.meta.action || null;
    },

    subject() {
      return this.$route.meta.subject || null;
    },
  },
  mounted() {
    this.$store.dispatch('loadInitialData');
  },
  methods: {
    onNewSocialPost() {
      this.$store.dispatch('channel/getChannels');
      this.$store.dispatch('modals/showSocialPostDialog');
    },

    onSearch(event) {
      this.$store.commit(`interaction/${interactionTypes.SET_SEARCH_TERM}`, event.searchTerm);
      this.$store.dispatch('interaction/simpleSearch', {
        query: event.searchTerm,
        page: 1,
      });
      this.$router.push({ name: 'InteractionSearch' });
    },

    onLogout() {
      this.$store.commit(`auth/${authTypes.LOGOUT_REQUEST}`);
    },

    onCollapseMenu() {
      this.$store.commit(appTypes.TOGGLE_SIDEBAR);
      const bodyEl = document.getElementsByTagName('body')[0];

      if (this.hasMiniNavbar(bodyEl)) {
        this.removeMiniNavbar(bodyEl);
      } else {
        this.addMiniNavbar(bodyEl);
      }
    },

    addMiniNavbar(el) {
      const bodyEl = el;
      if (bodyEl.classList) {
        bodyEl.classList.add('mini-navbar');
      } else {
        bodyEl.className += ' mini-navbar';
      }
    },

    removeMiniNavbar(el) {
      const bodyEl = el;
      if (bodyEl.classList) {
        bodyEl.classList.remove('mini-navbar');
      } else {
        bodyEl.className = bodyEl.className.replace(
          new RegExp('(^|\\b)mini-navbar(\\b|$)', 'gi'),
          ' ',
        );
      }
    },

    hasMiniNavbar(el) {
      if (el.classList) {
        return el.classList.contains('mini-navbar');
      }
      return new RegExp('(^| )mini-navbar( |$)', 'gi').test(el.className);
    },
  },
};
</script>



// WEBPACK FOOTER //
// MainApp.vue?43837ae8